import Dialog from "@hudson/ui/components/Dialogs/Simple";
import debugContext from "@lib/contexts/debug";
import classNames from "classnames";
import { useContext, useState } from "react";

export default function DebugInfo({
  children,
  className = "",
  dialogContent,
}: {
  children: React.ReactNode;
  className?: string;
  dialogContent?: JSX.Element | string;
}) {
  const [showDialog, setShowDialog] = useState(false);
  const { debugMode } = useContext(debugContext);

  return debugMode ? (
    <>
      {dialogContent && (
        <Dialog show={showDialog} onHide={() => setShowDialog(false)}>
          {dialogContent}
        </Dialog>
      )}
      <div
        style={{ backgroundColor: "rgb(234 172 172)" }}
        className={classNames(
          className,
          { "cursor-pointer": dialogContent },
          "shadow-sm rounded-lg text-base pl-2 pt-1 pb-1 pr-2 z-50",
        )}
        onClick={(e) => {
          if (dialogContent) setShowDialog(!showDialog);
          e.stopPropagation();
        }}
      >
        {children}
      </div>
    </>
  ) : null;
}
